
import React from 'react';
import './TableQuestions.scss';
import { idAnswersLoad, getIdSelectedQuestion, openInputFormsForQuestions,  
    openDeleteInputFormsForQuestions, openPreviewQuestionImgForms  } from '../../../../adminSlice.js';
import {divideText} from '../../../../../../helper/dividerForTextNote';

export default class TableQuestions extends React.Component {
    constructor(props) {
        super(props);

       this.onEdit = this.onEdit.bind(this);
       this.onGetAnswers = this.onGetAnswers.bind(this);
       this.onDelete = this.onDelete.bind(this);
       this.onPreviewQuestionImg = this.onPreviewQuestionImg.bind(this);
    }

   //GET ANSWERS BY ID
  
onGetAnswers(e) {
    const { dispatch } = this.props;
    //console.log(this.props.adminState.dataQuizes);

    //const id= e.currentTarget.value ;
    
   // console.log(id);
        const item = {
        id: e.currentTarget.value,
        sortQuestion: e.currentTarget.dataset.value1,
        
    }

    console.log(item);
   dispatch(idAnswersLoad(item));
   dispatch(getIdSelectedQuestion(item));
}
onEdit(e) {
    const { dispatch } = this.props;

   
        const item = {
        id: e.target.value,
        imgName: e.target.dataset.value1,
        
    }
    console.log(item);
    dispatch(openInputFormsForQuestions(item));

}
onPreviewQuestionImg(e) {
    const { dispatch } = this.props;

    
    const item = {
        id: e.target.value,
        imgName: e.target.dataset.value1,
        questionContent: e.target.dataset.value2,
    }
    console.log(item);
    dispatch(openPreviewQuestionImgForms(item));

}
onDelete(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openDeleteInputFormsForQuestions(id));

}
   renderTable() {
    let  data =  this.props.data;
    return (
        data.map(item => {
           // console.log(item.id + " " + item.label);
            return(
                
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                         
                            <button className='bigbtn'  value={item.id}  data-value1={item.sort_quest} onClick={this.onGetAnswers}
                             >{divideText(item.text)} (тип {item.sort_quest})
                            </button>
                         
                         <div className='edit'>
                            <button className='smallbtnEdit'value={item.id} data-value1={item.question_img} onClick={this.onEdit} ></button>
                            <button className='smallbtnDelete'value={item.id} onClick={this.onDelete}></button>
                            <button className='smallbtnPreviewImg'value={item.id} data-value1={item.question_img} data-value2={item.text} 
                            onClick={this.onPreviewQuestionImg} disabled ={item.question_img ? '' : 'disabled'}></button>
                         </div>
                        </td>
                    </tr>
                    
                

                )
            })
        )    
   }
   
    render() {

        return(
            <div className="TableQuestions">
                
                <table>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Вопрос</th>
                        </tr>
                        
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    
                    
                    </tbody>

                </table>
                
            </div>
        )
    }
}